import React, { useEffect } from 'react';
import ReactRoutes from './ReactRoutes';
import { ThemeProvider } from './context/ThemeContext';
import './colors.scss';

function App() {
  // Apply base styles
  useEffect(() => {
    // Add smooth scrolling
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Set initial theme
    const savedTheme = localStorage.getItem('theme');
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const initialTheme = savedTheme || (systemPrefersDark ? 'dark' : 'light');
    document.documentElement.setAttribute('data-theme', initialTheme);
    
    // Set viewport meta tag
    const metaViewport = document.createElement('meta');
    metaViewport.name = 'viewport';
    metaViewport.content = 'width=device-width, initial-scale=1, viewport-fit=cover';
    document.head.appendChild(metaViewport);
    
    // Set theme-color meta tag
    const metaThemeColor = document.createElement('meta');
    metaThemeColor.name = 'theme-color';
    metaThemeColor.content = initialTheme === 'dark' ? '#111827' : '#ffffff';
    document.head.appendChild(metaThemeColor);
    
    return () => {
      document.head.removeChild(metaViewport);
      document.head.removeChild(metaThemeColor);
    };
  }, []);

  return (
    <ThemeProvider>
      <div className="app" style={{
        minHeight: '100vh',
        backgroundColor: 'var(--bg-primary)',
        color: 'var(--text-primary)',
        transition: 'background-color 0.3s ease, color 0.3s ease',
      }}>
        <ReactRoutes />
      </div>
    </ThemeProvider>
  );
}

export default App;
